export class EventUsersController {
    constructor($scope, $location, UserService, EventService, $rootScope, $route) {
        this.scope = $scope;
        this.rootScope = $rootScope;
        this.location = $location;
        this.route = $route;
        this.UserService = UserService;
        this.EventService = EventService;

        this.init();
    }

    init() {
        this.eventId = this.route.current.params.id;
        this.scope.adsLimit = 5;
        this.scope.isLoadedPage = false;
        this.scope.isLoadedPage = this.rootScope.content.location === this.location.path();
        this.filterLocation = this.location.search();
        this.scope.options = {};

        if(this.filterLocation.age >= 0 && this.filterLocation.age <= 4) {
          this.scope.options.age = this.filterLocation.age;
        } else {
          this.scope.options.age = "0";
        }

        if(this.filterLocation.gender >= 1 && this.filterLocation.gender <= 2) {
          this.scope.options.gender = this.filterLocation.gender;
        } else {
          this.scope.options.gender = "0";
        }

        this.scope.setFilter = () => {
            this.rootScope.content.page = 1;
            this.rootScope.content.items = [];
            this.loadMore();
        };

        this.scope.canLoadMore = () => {
            return this.rootScope.content.pageCount >= this.rootScope.content.page;
        };

        this.scope.loadMore = () => {
            this.loadMore();
        };

        if(this.rootScope.content.location !== this.location.path()) {
            this.rootScope.content.items = [];
            this.rootScope.content.page = 1;
            this.rootScope.content.pageCount = 0;
            this.rootScope.content.limit = 18;
            this.rootScope.content.maxItem = 0;
            this.rootScope.content.location = this.location.path();

            this.UserService.getCurrentUser()
                .then((response) => { let user = response.data;
                    this.rootScope.currentUserProfile = user.data;
                })
                .catch((response) => { let err = response.data;
                    console.error(err);
                });

            this.loadMore();
        }
    }

    loadMore() {
          if(this.scope.loading) return;
          this.scope.loading = true;
          this.location.search('age', this.scope.options.age);
          this.location.search('gender', this.scope.options.gender);

          let request = {
              eventId: this.eventId,
              gender: this.scope.options.gender,
              age: this.getFilterAge(this.scope.options.age),
              page: this.rootScope.content.page,
              limit: this.rootScope.content.limit
          };

        this.EventService.getEventUsers(request)
            .then((_res) => { let response = _res.data;
                this.rootScope.content.maxItem = response.itemCount;
                this.rootScope.content.pageCount = response.pageCount;
                if(!this.rootScope.isVip()) {
                    let period = 9;
                    let countAds = Math.floor(response.data.length / period);
                    //insert ads after period
                    for(let i = 0; i < countAds; i++) {
                        if(this.scope.adsLimit > 0 && (i != 0 || this.rootScope.content.page != 1)) {
                            response.data.splice(i * period, 0, {_id: Date.now() + i, banner: true});
                            this.scope.adsLimit--;
                        }
                    }
                }
                this.rootScope.content.items = this.rootScope.content.items.concat(response.data);
                this.rootScope.content.items = _.uniqBy(this.rootScope.content.items, item => item._id);
                this.rootScope.content.page++;
                this.scope.isLoadedPage = true;
                this.scope.loading = false;
            })
            .catch((response) => { let err = response.data;
                this.scope.isLoadedPage = true;
                this.scope.loading = false;
                console.error(err);
            });
    }

    getFilterAge(param) {
        switch (param) {
            case '1': return {from: 18, to: 25};
            case '2': return {from: 26, to: 35};
            case '3': return {from: 36, to: 44};
            case '4': return {from: 45, to: 100};
            default: return {from: 18, to: 100};
        }
    }
}
